import { HeaderConfig } from '../models';
import { HeaderSettingsService } from '../services/internal';

export function HeaderInitializerFactory(
    headerSettingsService: HeaderSettingsService,
    headerSettingsMapper: (appSettings: unknown) => HeaderConfig
) {
    return async (): Promise<void> => {
        // Load app settings
        await headerSettingsService.initializeApp(headerSettingsMapper);
    };
}
